export default "__VITE_ASSET__4bd490da__"